import { PositionModel } from '@modules/position/position-model';

const { fields } = PositionModel;

export default [
  fields.name,
];
